import React from 'react';
import {withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import Toolbar from '../../components/Toolbar/Toolbar';
import Paper from '@material-ui/core/Paper';
import AttachmentTypesList from '../../components/Attachment/AttachmentTypesList';

const AttachmentTypesIndex = ({types, classes}) => {
    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('file.type_form.heading')}
                subtitle={''}
                items={[
                    // {
                    //     icon: 'add',
                    //     text: i18n.get('project.status_form.add'),
                    //     href: `/project/create`,
                    // },
                ]}
            />

            <Paper className={classes.paper}>
                <AttachmentTypesList types={types} />
            </Paper>



        </Layout>
    );
};

const styles = theme => ({
    span: {
        display: 'inline',
        margin: '0 5px',
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(AttachmentTypesIndex);
